<template>
    <div class="sec-cont">
        <Head :title="title"/>
        <div class="max-w-full bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="update">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                    <text-input v-model="form.first_name" :error="form.errors.first_name"
                                class="pb-8 pr-6 w-full lg:w-1/3" :label="__('First name')"
                    />
                    <text-input v-model="form.last_name" :error="form.errors.last_name"
                                class="pb-8 pr-6 w-full lg:w-1/3" :label="__('Last name')"
                    />
                    <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/3"
                                :label="__('Email')"
                    />
                    <text-input v-model="form.phone" :error="form.errors.phone" class="pb-8 pr-6 w-full lg:w-1/3"
                                :label="__('Phone')"
                    />
                    <select-input v-model="form.locale" :error="form.errors.locale" class="pr-6 pb-8 w-full lg:w-1/3"
                                  :label="__('Language')"
                    >
                        <option :value="null"/>
                        <option v-for="language in languages" :key="language.code" :value="language.code">
                            {{ __(language.name) }}
                        </option>
                    </select-input>
                    <text-input v-model="form.address" :error="form.errors.address" class="pb-8 pr-6 w-full"
                                :label="__('Address')"
                    />
                    <text-input v-model="form.password" :error="form.errors.password" class="pb-8 pr-6 w-full lg:w-1/3"
                                type="password" autocomplete="new-password" :label="__('Password')"
                    />
                    <file-input v-model="form.photo" :error="form.errors.photo" class="pb-8 pr-6 w-full lg:w-1/3"
                                type="file" accept="image/*" label="Photo"
                    />
                    <div class="w-full lg:w-1/3 flex items-center justify-start">
                        <img v-if="user.photo_path" class="block mb-2 w-8 h-8 rounded-full" :src="user.photo_path"/>
                    </div>
                </div>
                <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">
                        {{ __('Update User') }}
                    </loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
    components: {
        FileInput,
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
    },
    layout: Layout,
    props: {
        user: Object,
        auth: Object,
        languages: Object,
        countries: Array,
        cities: Array,
        title: String,
    },
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                _method: 'put',
                first_name: this.user.first_name,
                last_name: this.user.last_name,
                email: this.user.email,
                phone: this.user.phone,
                locale: this.user.locale,
                address: this.user.address,
                password: '',
                role: this.user.role,
                role_id: this.user.role_id,
                photo: null,
            }),
        }
    },
    created() {
        // this.setDefaultValue(this.countries, 'country_id', 'United States')
    },
    methods: {
        setDefaultValue(arr, key, value) {
            const find = arr.find(i => i.name.match(new RegExp(value + '.*')))
            if (find) {
                this.form[key] = find['id']
            }
        },
        update() {
            this.form.post(this.route('users.update', this.user.id), {
                onSuccess: () => this.form.reset('password', 'photo'),
            })
        },
    },
}
</script>
